export function getPowerRecommendedOpAmpRequirementSpec(stopbandFrequency) {
  var specs = {
    fMultiplier: 50, //bigger is more strict:  used for highpass
    allowedError: 0.05, //smaller is more strict: used lowpass and bandpass
    rOutFreqMultiplier: 3, //rout shouldn't come into play until 3x stopband
    inductorMultiplier: 5,
    dcOutputVoltageFromIBias: 0.2,
    stopbandFrequency: stopbandFrequency,
  };

  var result = adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

  return result;
}

export function getNoiseAndVoltageRangeOpAmpRequirementSpec(stopbandFrequency) {
  var specs = {
    fMultiplier: 200, //bigger is more strict:  used for highpass
    allowedError: 0.02, //smaller is more strict: used lowpass and bandpass
    rOutFreqMultiplier: 5, //rout shouldn't come into play until 5x stopband
    dcOutputVoltageFromIBias: 0.2,
    stopbandFrequency: stopbandFrequency,
    inductorMultiplier: 4,
  };

  var result = adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

  return result;
}

export function getAllowedOpAmpRequirementSpec(stopbandFrequency) {
  var specs = {
    fMultiplier: 5, //bigger is more strict:  used for highpass
    allowedError: 0.2, //Don't make this 0.5 or larger. In high speed cases, gets multiplied by 2, then low pass first order chokes when 1 or higher.
    rOutFreqMultiplier: 1, //rout shouldn't come into play until 1x stopband
    inductorMultiplier: 3,
    dcOutputVoltageFromIBias: 5,
    stopbandFrequency: stopbandFrequency,
  };

  var result = adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

  return result;
}

function adjustOpAmpRequirementSpecs(specs, stopbandFrequency) {
  /*If getting to top end of tool, allow more leeway*/
  if (stopbandFrequency > 1e6 && stopbandFrequency < 10e6) {
    specs.fMultiplier = specs.fMultiplier / 1.5;
    specs.allowedError = specs.allowedError * 1.5;
    specs.rOutFreqMultiplier = specs.rOutFreqMultiplier / 2;
  }
  if (stopbandFrequency >= 10e6) {
    specs.fMultiplier = specs.fMultiplier / 5;
    specs.allowedError = specs.allowedError * 2; //Be careful making this higher than 2. If allowedError * this number >= 1, then low pass first order chokes.
    specs.rOutFreqMultiplier = specs.rOutFreqMultiplier / 10;
  }

  return specs;
}
